<script setup lang="ts">
import { defineAsyncComponent, ref } from 'vue';
const Sidebar = defineAsyncComponent(() => import('./parts/AdminSidebar.vue'));
const Headerbar = defineAsyncComponent(() => import('./parts/AdminHeader.vue'));

const sidebarRemoved = ref(false);
</script>
<template>
  <Sidebar v-if="!sidebarRemoved" />
  <div class="main--content">
    <Headerbar />
    <slot />
  </div>
</template>
